import React from 'react';
import pkceChallenge from 'pkce-challenge';

import EmailFlowControl from '../../components/MyInfo/MyinfoEditable/EmailFlowControl';
import MarriageRadio from '../../components/MyInfo/MyinfoEditable/marriageRadio';
import MobileFlowControl from '../../components/MyInfo/MyinfoEditable/MobileFlowControl';
import { fetcherApiRoute } from '../api/fetcher';
import encodeUri from '../encode-uri';

const redirectToMyinfoVerify = ({ myinfoClientId, isPersonaEnabled }) => {
  fetcherApiRoute(isPersonaEnabled ? '/api/v2/myinfo-scope' : '/api/myinfo-scope', {
    method: 'GET',
  })
    .then((res) => {
      const scope = res.scope.join(' ');
      const myinfoNonce = crypto.randomUUID();
      localStorage.setItem('myinfo_nonce', myinfoNonce);
      pkceChallenge(128).then((pcke) => {
        localStorage.setItem('code_verifier', pcke.code_verifier);
        const myinfoConfigtest = {
          scope,
          client_id: myinfoClientId,
          redirect_uri: process.env.MYINFO_REDIRECT_URI,
          state: crypto.randomUUID(),
          nonce: myinfoNonce,
          response_type: 'code',
          code_challenge_method: 'S256',
          code_challenge: pcke.code_challenge,
        };
        const myinfoEndpoint = `${process.env.MYINFO_HOST}/auth?${encodeUri(myinfoConfigtest)}`;
        window.location.href = myinfoEndpoint;
      });
    })
    .catch(() => {
      window.location.href = '/';
    });
};

const checkMyinfoStatusApiError = (myinfoError) => {
  return myinfoError.length > 0;
};

const getSideSheetTitle = (labelValue) => {
  switch (labelValue) {
    case 'email':
      return 'Edit email';
    case 'mobileno':
      return 'Edit mobile number';
    case 'marital':
      return 'Marital status';
    default:
      return null;
  }
};

const handleCloseSideSheet = (callback) => {
  callback(false);
};

const handleOpenSideSheet = (sideSheetStateCallback, sideSheetFlowCallback, keyValue) => {
  sideSheetStateCallback(true);
  sideSheetFlowCallback(keyValue);
};

const GetEditableFlow = (props) => {
  switch (props.keyValue) {
    case 'email':
      return <EmailFlowControl {...props} />;
    case 'mobileno':
      return <MobileFlowControl {...props} />;
    case 'marital':
      return <MarriageRadio {...props} />;
    default:
      return null;
  }
};

const handleMyinfoError = (e, router, setMyinfoError, defaultError) => {
  if (e.message.startsWith('[MYINFO_CONFLICT]')) {
    const myinfoConflictDataRaw = e.message.split('[MYINFO_CONFLICT] ')[1];
    const myinfoConflictData = JSON.parse(myinfoConflictDataRaw);
    localStorage.setItem(
      'myinfo_conflict',
      JSON.stringify({
        email: myinfoConflictData.email,
        errorTitle: myinfoConflictData.errorTitle,
        errorMessage: myinfoConflictData.errorMessage,
      }),
    );
    router.push('/');
  } else {
    setMyinfoError(e.message || defaultError);
  }
};

const checkMobileIsNil = (key, value) => {
  return key === 'mobileno' && value === 'Nil';
};

const checkPreventCallingConfirmApi = (dataArray) => {
  for (const data of dataArray) {
    const key = data.key;
    const value = data.value;
    if (checkMobileIsNil(key, value)) {
      return true;
    }
  }
  return false;
};

const newMyinfoPopupTitles = [
  'Discount Scheme Eligibility (Merdeka and Pioneer Generation)',
  'Residential Status',
  'Registered Address',
];

const getTrackingScreenSection = ({ isEmailVerified, isMobileVerified }) => {
  if (isEmailVerified && isMobileVerified) {
    return 'widget | verified email and mobile';
  } else if (isEmailVerified && !isMobileVerified) {
    return 'widget | verified email';
  } else if (isMobileVerified && !isEmailVerified) {
    return 'widget | verified mobile';
  } else {
    return 'widget | unverified';
  }
};

export {
  redirectToMyinfoVerify,
  checkMyinfoStatusApiError,
  getSideSheetTitle,
  handleCloseSideSheet,
  handleOpenSideSheet,
  GetEditableFlow,
  handleMyinfoError,
  checkMobileIsNil,
  checkPreventCallingConfirmApi,
  newMyinfoPopupTitles,
  getTrackingScreenSection,
};
